<template>
  <USelectMenu
    v-model="currentValue"
    :items="items"
    label-key="title"
    by="idForm"
    :placeholder="placeholderValue"
    :filter-fields="['title']"
    :disabled="!items.length"
  >
    <template #default="{ modelValue: selected }">
      <div v-if="selected" class="flex items-center h-full pr-2 text-sm text-gray-800 dark:text-gray-100">
        {{ selected.title }}
      </div>
    </template>

    <template #item="{ item }">
      <div class="flex items-center">
        {{ item.title }}
      </div>
    </template>
  </USelectMenu>
</template>

<script setup lang="ts">
import { useFormStore } from '~/stores/useFormStore'

const { $i18n } = useNuxtApp()
const formStore = useFormStore()

interface Props {
  modelValue?: Record<string, any> | any[] | null
  filter?: Function | null
  fieldClass?: string
  placeholder?: string
}

const props = withDefaults(defineProps<Props>(), {
  modelValue: null,
  filter: null,
  fieldClass: 'text-sm',
  placeholder: undefined,
})

const emit = defineEmits<{
  (e: 'update:modelValue', value: any): void
}>()

const placeholderValue = computed(() => {
  return props.placeholder ?? $i18n.t('form.select')
})

const currentValue = computed({
  get () {
    return props.modelValue
  },
  set (value: any) {
    emit('update:modelValue', value)
  },
})

const forms = computed(() => formStore.all)

const items = computed(() => {
  let formsList = forms.value

  if (props.filter) {
    formsList = formsList.filter(props.filter as any)
  }

  return [...formsList].sort((a: any, b: any) => a.listOrder - b.listOrder)
})

onMounted(() => {
  formStore.sync()
})
</script>
